import { Controller } from "@hotwired/stimulus"

// Replaces Phoenix navbarShadowOnScrollInit (app/assets/vendor/js/phoenix.js)
export default class extends Controller {
  static values = {
    // Phoenix used 300px; a lower default makes the effect obvious without long scroll.
    threshold: { type: Number, default: 12 }
  }

  connect() {
    this._onScroll = this._onScroll.bind(this)
    window.addEventListener("scroll", this._onScroll, { passive: true })
    document.addEventListener("turbo:load", this._onScroll)
    this._onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this._onScroll)
    document.removeEventListener("turbo:load", this._onScroll)
  }

  _scrollTop() {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    )
  }

  _onScroll() {
    if (this._scrollTop() > this.thresholdValue) {
      this.element.classList.add("navbar-shadow")
    } else {
      this.element.classList.remove("navbar-shadow")
    }
  }
}
